import AlltSeller from './AlltSeller';
import AsSeller from './AsSeller';
import BorgSeller from './BorgSeller';
import EignarmidlunSeller from './EignarmidlunSeller';
import EignaverSeller from './EignaverSeller';
import FasteignavalSeller from './FasteignavalSeller';
import GimliSeller from './GimliSeller';
import HeimiliSeller from './HeimiliSeller';
import KaupstadurSeller from './Kaupstadur';
import LandmarkSeller from './Landmark';
import LindSeller from './LindSeller';
import MiklaborgSeller from './MiklaborgSeller';
import ProcuraSeller from './ProcuraSeller';
import RemaxSeller from './RemaxSeller';
import SaevarthorfasteignirSeller from './SaevarthorfasteignirSeller';
import ViltuSeller from './Viltu';

export default [
  new AlltSeller(),
  new AsSeller(),
  new BorgSeller(),
  new EignarmidlunSeller(),
  new EignaverSeller(),
  new FasteignavalSeller(),
  new GimliSeller(),
  new HeimiliSeller(),
  new KaupstadurSeller(),
  new LandmarkSeller(),
  new LindSeller(),
  new MiklaborgSeller(),
  new ProcuraSeller(),
  new RemaxSeller(),
  new SaevarthorfasteignirSeller(),
  new ViltuSeller(),
];
